// Central brand mark for Doxa School (V4-02D).
// Monochrome graduation-cap glyph (currentColor) on the brand orange block.
export function BrandGlyph({ className = "" }) {
  return (
    <svg viewBox="0 0 64 64" className={className} fill="currentColor" aria-hidden="true" focusable="false">
      {/* Mortarboard board */}
      <path d="M32 8 L62 22 L32 36 L2 22 Z" />
      {/* Book / base with center dip and bottom V-notch */}
      <path d="M14 30 C21 35 27 37 32 37 C37 37 43 35 50 30 L50 51 L33 58 L32 54 L31 58 L14 51 Z" />
    </svg>
  );
}

const BLOCK = {
  sm: "w-8 h-8 rounded-lg",
  md: "w-10 h-10 rounded-xl",
  lg: "w-12 h-12 rounded-xl",
  xl: "w-14 h-14 rounded-2xl",
};
const GLYPH = {
  sm: "w-4 h-4",
  md: "w-5 h-5",
  lg: "w-6 h-6",
  xl: "w-7 h-7",
};

export function BrandMark({ size = "md", className = "" }) {
  return (
    <div
      className={`bg-[#F75A1B] flex items-center justify-center shrink-0 ${BLOCK[size] || BLOCK.md} ${className}`}
      data-testid="brand-mark"
    >
      <BrandGlyph className={`text-white ${GLYPH[size] || GLYPH.md}`} />
    </div>
  );
}

export default BrandMark;
